import { Footer, Header, SEO } from "@/components";
import SEOConfig from "@/common/seo.config";
import { fetchBlogList } from "@/lib/blogs";
import { HOME_BLOG_LIMIT } from "@/components/main/aiBlog";
import { fetchServiceSolutions } from "@/lib/service-solutions";
import RelatedSolutionsComponent from "@/common/related-solutions";
import CustomLlmDevelopmentComponent, {
  FAQS,
} from "@/components/services/custom-llm-development";
import React from "react";
import { buildServicePageSchema } from "@/lib/service-page-schema";

const PATH = "/custom-llm-application-development";

function CustomLlmApplicationDevelopment({ posts = [], relatedSolutions = [] }) {
  return (
    <>
      <SEO
        {...SEOConfig.customLlmApplicationDevelopment}
        structuredData={buildServicePageSchema({
          config: SEOConfig.customLlmApplicationDevelopment,
          path: PATH,
          faqs: FAQS,
          serviceType: "Custom LLM Application Development",
        })}
      />
      <Header />
      <main>
        <CustomLlmDevelopmentComponent posts={posts} />
        <RelatedSolutionsComponent
          data={relatedSolutions}
          title="Solutions built on this capability"
          subtitle="Where we apply this work for specific teams and industries."
        />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const [posts, relatedSolutions] = await Promise.all([
    fetchBlogList({ limit: HOME_BLOG_LIMIT }),
    fetchServiceSolutions(PATH),
  ]);

  return {
    props: { posts, relatedSolutions },
    revalidate: 300,
  };
}

export default CustomLlmApplicationDevelopment;
